import { useMemo } from "react";
import { useGetTiCardData } from "../../search/components/ticard/hooks";
import useGetCombinedActorData from "./useGetCombinedActorData";
import useGetIOCSummary from "./useGetIOCSummary";

interface UseAttributionDataParams {
  ioc: string;
  threatName?: string;
}

const useAttributionData = ({ ioc, threatName }: UseAttributionDataParams) => {
  const { data: malwareFamilyData } = useGetTiCardData(threatName);
  const { data: iocData, isLoading: isIocLoading } = useGetIOCSummary(ioc);

  const actors = useMemo(() => {
    const iocActors = iocData?.related_actors ?? [];
    const malwareFamilyActors = malwareFamilyData?.rl?.general?.actor ?? [];

    return [
      ...new Set([
        ...iocActors.map(actor => actor.name),
        ...malwareFamilyActors.map(actor => actor.name)
      ])
    ];
  }, [iocData, malwareFamilyData]);

  const {
    combinedIOCs,
    combinedSources,
    isLoading: isCombinedActorDataLoading
  } = useGetCombinedActorData(actors);

  const getActorName = (index: number) => actors[index];

  const getActorDescription = (index: number) => {
    const actorName = getActorName(index);
    return malwareFamilyData?.rl?.general?.actor?.find(
      actor => actor.name === actorName
    )?.description;
  };

  return {
    iocData,
    malwareFamilyData,
    actors,
    combinedIOCs,
    combinedSources,
    isIocLoading,
    isCombinedActorDataLoading,
    getActorName,
    getActorDescription
  };
};

export default useAttributionData;
